export default [
	{
		modulo: 38,
		privilegio: 370,
		routerName: 'treinamentos',
		routerPath: '/treinamentos',
		componentName: 'Treinamento',
		componentPath: 'modules/layout/treinamento/main',
	},
	{
		modulo: 38,
		privilegio: 372,
		routerName: 'grupo-treinamentos',
		routerPath: '/grupo-treinamentos',
		componentName: 'GrupoTreinamento',
		componentPath: 'modules/layout/treinamento/agrupar-treinamentos/main',
	},
	{
		modulo: 38,
		privilegio: 371,
		routerName: 'turmas-treinamento',
		routerPath: '/turmas-treinamento',
		componentName: 'turmasTreinamento',
		componentPath: 'modules/layout/treinamento/turmas/main',
	},

	{
        modulo: 38,
		privilegio: 371,
		props: true,
		routerName: 'turmas-treinamento-form',
		routerPath: '/turmas-treinamento/:id',
		componentName: 'TurmaTreinamento',
		componentPath: 'modules/layout/treinamento/turmas/cadastro'
	},

	{
        modulo: 38,
		privilegio: 370,
		props: true,
		routerName: 'area-do-aluno',
		routerPath: '/area-aluno',
		componentName: 'AreaDoAluno',
		componentPath: 'modules/layout/treinamento/area-do-aluno/cardAluno'
	},
	{
        modulo: 38,
		privilegio: 370,
		props: true,
		routerName: 'historico-aluno',
		routerPath: '/historico/:id',
		componentName: 'HistoricoAluno',
		componentPath: 'modules/layout/treinamento/area-do-aluno/historico'
	},
	{
        modulo: 38,
		privilegio: 385,
		props: true,
		routerName: 'treinamento-manual',
		routerPath: '/treinamento-manual',
		componentName: 'TreinamentoManual',
		componentPath: 'modules/layout/treinamento/area-do-aluno/treinamentoManual'
	},
	{
        modulo: 38,
		privilegio: 383,
		props: true,
		routerName: 'area-do-gestor',
		routerPath: '/area-gestor',
		componentName: 'AreaDoGestor',
		componentPath: 'modules/layout/treinamento/area-do-aluno/AreaDoGestor'
	},

]
